import { StageConfig, StageId } from "./types";

/** デバッグフラグ */
export const DEBUG = false;

/** ゲーム画面サイズ */
export const GAME_WIDTH = 480;
export const GAME_HEIGHT = 800;

/** スコア基本点 */
export const BASE_POINT = 10;

/** コンボ上限 */
export const COMBO_MULT_MIN = 1.0;
export const COMBO_MULT_MAX = 5.0;
export const COMBO_INCREMENT = 0.1;

/** EMA設定 */
export const EMA_ALPHA = 0.25;
export const EMA_INITIAL_MS = 900;
export const SPEED_FAST_MS = 250;
export const SPEED_SLOW_MS = 1200;

/** 精度ファクターの閾値 */
export const ACCURACY_THRESHOLDS = [
  { maxMisses: 0, factor: 1.0 },
  { maxMisses: 2, factor: 0.85 },
  { maxMisses: 4, factor: 0.7 },
] as const;
export const ACCURACY_FALLBACK = 0.55;

/** 文完走ボーナス基本点 */
export const COMPLETION_BONUS_BASE = 50;
export const COMPLETION_BONUS_LENGTH_DIVISOR = 5;

/** ステージ別設定 */
export const STAGE_CONFIGS: Record<StageId, StageConfig> = {
  S1: { id: "S1", lengthMin: 2, lengthMax: 5, wordRatio: 0.85, fallSpeed: 18, stageFactor: 1.0 },
  S2: { id: "S2", lengthMin: 5, lengthMax: 6, wordRatio: 0.70, fallSpeed: 24, stageFactor: 1.05 },
  S3: { id: "S3", lengthMin: 8, lengthMax: 10, wordRatio: 0.75, fallSpeed: 30, stageFactor: 1.10 },
  S4: { id: "S4", lengthMin: 11, lengthMax: 13, wordRatio: 0.30, fallSpeed: 36, stageFactor: 1.15 },
  S5: { id: "S5", lengthMin: 14, lengthMax: 15, wordRatio: 0.10, fallSpeed: 42, stageFactor: 1.20 },
};

/** ステージ昇格スコア閾値 */
export const STAGE_THRESHOLDS: { stage: StageId; score: number }[] = [
  { stage: "S2", score: 10000 },
  { stage: "S3", score: 30000 },
  { stage: "S4", score: 80000 },
  { stage: "S5", score: 150000 },
];

/** ステージ順序 */
export const STAGE_ORDER: StageId[] = ["S1", "S2", "S3", "S4", "S5"];

/** WordBank: 直近重複回避件数 */
export const RECENT_SET_SIZE = 5;

/** FallingChar: 重力加速度（px/s^2） */
export const FALLING_GRAVITY = 400;

/** 敵文字のフォントサイズ */
export const ENEMY_FONT_SIZE = 32;

/** 次の正解文字パネルのフォントサイズ */
export const NEXT_CHAR_FONT_SIZE = 48;
